export const WORK_DAY_SEGMENT_TYPES = [
  'WORK',
  'REST',
  'INFERRED_REST',
  'AVAILABLE',
  'UNKNOWN',
] as const

export type SegmentType = (typeof WORK_DAY_SEGMENT_TYPES)[number]

export type WorkDaySegment = {
  id: string
  segmentType: string
  datetimeStart: string
  datetimeEnd: string
}

export function isWorkDaySegmentType(
  segmentType: string
): segmentType is SegmentType {
  return WORK_DAY_SEGMENT_TYPES.some(candidate => candidate === segmentType)
}
